import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-photo-gallery',
  templateUrl: './add-photo-gallery.component.html',
  styleUrls: ['./add-photo-gallery.component.css']
})
export class AddPhotoGalleryComponent implements OnInit {

  arr = []
  showImage = false
  photoarr = []
  dummyError = []
  baseUrl = environment.imgUrl;
  constructor(private authService: AuthservicesService,public router: Router) { }

  ngOnInit(): void {
    this.getPhotoGallery()
  }

  getPhotoGallery() {
    this.authService.getGalleryImages().subscribe((res: any) => {
      const images = res?.data?.images || []
      this.photoarr = [...images]
      this.arr = images.map(() => ({ show: true, showLoader: false, deleteImage: false }))

      if (this.arr.length < 6) {
        this.arr.push({ show: false, showLoader: false, deleteImage: false })
      }

      this.dummyError = Array.from({ length: 6 - images.length }, () => 1)
    },
      error => {
        console.log(error)
      })
  }

  uploadImage(event, i) {

    if (this.photoarr.length == 6) {
      return
    }

    this.arr[i]['showLoader'] = true
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('image', file, file.name);
      formData.append('imageType', 'profilePic');
      this.authService
        .upload(formData)
        .subscribe(
          data => {

            if (this.photoarr.length != 0) {
              this.photoarr[i] = data['data'].url
              this.arr[i]['show'] = true
            }

            else {
              this.arr[i]['show'] = true

              this.photoarr.push(
                data['data'].url,
              )

            }
            if (this.arr.length < 6) {
              this.arr.push({ show: false, showLoader: false, deleteImage: false })
              this.dummyError.pop()
            }
          },
          error => {
            this.arr[i]['showLoader'] = false

            this.authService.successMessage(error.error.message, 'error')
          }
        );
    } else {
      this.authService.successMessage('Error', 'error')
    }
  }
  renderImage(e) {
    console.log('e--------',e);
    if (e !== undefined || e !== null) {
      const [baseUrl, imgUrl] = e.split('uploads');
      console.log('mmmmmmmmmmmmmmmm',`${this.baseUrl}uploads${imgUrl}`)
      return `${this.baseUrl}uploads${imgUrl}`
    } else {
      return 'assets/images/church.jpeg'
      // return 'http://onwardstate.com/wp-content/uploads/2013/03/2645293-bryan-cranston-stars-as-walter-white-in-breaking-bad_super.jpg';
    }
    // let image = this.authService.spilturl(e)
    // return image
  }


  deleteImage(i) {
    if (this.photoarr.length == 0) {
      return
    }

    this.arr[i].deleteImage = true
    setTimeout(() => {
      this.arr[i].deleteImage = false
      this.photoarr.splice(i, 1)
      this.arr.splice(i, 1)
      if (this.arr.length < 6) {
        this.arr.push({ show: false, showLoader: false, deleteImage: false })
      }
      this.dummyError = Array.from({ length: 6 - this.photoarr.length }, () => 1)
    }, 1000)
    console.log('photoarr------',this.photoarr)
    console.log('arr--------',this.arr)
  }

  onSubmit() {
    if (this.photoarr.length == 0) {
      return
    }

    this.authService.onphotoGallery({ imagePath: this.photoarr }).subscribe((res: any) => {
      console.log('%%%%%%',res);
      if(res.code == 200){
        this.authService.successMessage('Photo gallery has been saved', 'success')
        this.router.navigate(["/photo-gallery"]);
      }
    },
      error => {
        console.log(error)
      }
    )

  }




}
